<orders-filter-form
  [customerOptions]="(customerOptions$ | ngrxPush)!"
  [filters]="(filters$ | ngrxPush)!"
  [fleetOptions]="(fleetOptions$ | ngrxPush)!"
  (filtersChange)="onFiltersChange($event)"
  (resetFilters)="resetClick()"
/>
